export default {
    data () {
        return {
            shopGoodsTypeList: [
                { id: 0, label: 'ไอที' },
                { id: 1, label: 'เครื่องใช้ไฟฟ้า' },
                { id: 2, label: 'เครื่องมือช่าง' },
                { id: 3, label: 'ของใช้สำหรับเด็กและทารก' },
                { id: 4, label: 'กระเป๋าเดินทาง' },
                { id: 5, label: 'เกมกระดาน' },
                { id: 6, label: 'วัสดุก่อสร้าง' },
                { id: 7, label: 'กล่อง, ภาพถ่าย' },
                { id: 8, label: 'เกี่ยวกับรถยนต์' },
                { id: 9, label: 'เสื้อผ้า' },
                { id: 10, label: 'ยารักษาโรค' },
                { id: 11, label: 'อาหาร, เครื่องดื่ม' },
                { id: 12, label: 'เกม, ของเล่น' },
                { id: 13, label: 'สุขภาพ, ความงาม' },
                { id: 14, label: 'เครื่องใช้ในครัวเรือน' },
                { id: 15, label: 'อาหาร' },
                { id: 16, label: 'อุปกรณ์สำนักงาน' },
                { id: 17, label: 'ระเบียง, สวน' },
                { id: 18, label: 'อื่นๆ' }
            ],
            bankAccountTypeList: [
                { id: 0, label: 'บุคคลทั่วไป' },
                { id: 1, label: 'นิติบุคคล' }
            ]
        }
    },
    methods: {
        getShopGoodsType (shopGoodsTypeID) {
            return this.shopGoodsTypeList.filter((e) => { return e.id === shopGoodsTypeID })[0].label
        },
        getBankAccountType (id) {
            return this.bankAccountTypeList.filter((e) => { return e.id === id })[0].label
        },
        compareLabel (a, b) {
            const genreA = a.label.toUpperCase()
            const genreB = b.label.toUpperCase()
            let comparison = 0
            if (genreA > genreB) {
                comparison = 1
            } else if (genreA < genreB) {
                comparison = -1
            }
            return comparison
        },
        compareOrderFailLogCreateShipment (a, b) {
            if (a.orderFailCount > b.orderFailCount) {
                return -1
            }
            if (a.orderFailCount < b.orderFailCount) {
                return 1
            }
            return 0
        }
        // how to use Array.concat().sort(sortBy("name"));
        // sortBy (key) {
        //     return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0)
        // }

    }
}
